module.exports = __webpack_public_path__ + "cement/img/jianbao.981cfb1a.png";